import React, { useState, useMemo } from 'react';
import styled from '@emotion/styled';
import { ThemeProvider, CacheProvider } from '@emotion/react';
import { cache } from '@emotion/css';
import { zooplaRebrandTheme } from '@blueprint/theme';
import { theme } from '@blueprint/ui';

const isDev = process.env.NODE_ENV !== 'production';

enum ThemeName {
    original = 'original',
    rebrand = 'rebrand'
}

const getTheme = (themeName: ThemeName, isDev: boolean) => {
    if (!isDev) return theme;
    return {
        [ThemeName.original]: theme,
        [ThemeName.rebrand]: zooplaRebrandTheme
    }[themeName];
};

const StyledToggleButton = styled.button`
    position: fixed;
    top: 10px;
    left: 10px;
    z-index: 9999;
`;

const DevToggleButton: React.FC<{ onClick: () => void }> = ({ onClick }) => {
    return !isDev ? null : (
        <StyledToggleButton onClick={onClick}>Toggle Theme</StyledToggleButton>
    );
};

export const RebrandThemeProvider: React.FC = ({ children }) => {
    const [themeName, setThemeName] = useState<ThemeName>(ThemeName.original);
    const theme = useMemo(() => getTheme(themeName, isDev), [themeName, isDev]);

    const toggleTheme = () => {
        setThemeName(
            themeName === ThemeName.original
                ? ThemeName.rebrand
                : ThemeName.original
        );
    };

    return (
        <CacheProvider value={cache}>
            <DevToggleButton onClick={toggleTheme} />
            <ThemeProvider theme={theme}>{children}</ThemeProvider>
        </CacheProvider>
    );
};
